import PprCell from './component'

export default PprCell
